import requireModule from 'src/require-module'

require("src/load-globals");

requireModule('student/announcement/listing');

requireModule('student/course/dashboard');
requireModule('student/course/portal');
requireModule('student/course/faq');
requireModule('student/course/learning_module');

requireModule('student/resource/index');

requireModule('student/coursework/listing');
requireModule('student/coursework/form_submission');
requireModule('student/coursework/detail');

requireModule('student/gradebook/listing');
requireModule('student/gradebook/charts');
requireModule('student/gradebook/file_submission');

requireModule('student/session/listing');

requireModule('common/session/detail');
requireModule('common/session/related_material');

requireModule('common/coursework/gallery/overview');
requireModule('common/coursework/gallery/detail');

requireModule('common/resource/show');
requireModule('common/resource/coupon_view');
requireModule('common/resource/info_modal');

requireModule('common/messenger');

requireModule('common/forum_thread/index');
requireModule('common/forum_thread/embedded');
requireModule('common/forum_thread/show');
requireModule('common/forum_thread/edit');

requireModule('common/left_nav');
requireModule('common/top_nav');

requireModule('common/course/syllabus');
requireModule('common/course/block_syllabus');

requireModule('user/portfolio/detail');
requireModule('user/confirmation_required');

requireModule('common/search/results');

requireModule('user/enrollment_info');

requireModule('common/placeholder');
